/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'fabric.atlassianSwitcher.administration': 'Administration',
  'fabric.atlassianSwitcher.analytics': 'Analysen',
  'fabric.atlassianSwitcher.assets': 'Assets',
  'fabric.atlassianSwitcher.atlassianHome': 'Startseite',
  'fabric.atlassianSwitcher.atlassianWebsiteTryProducts': 'Atlassian-Produkte testen',
  'fabric.atlassianSwitcher.autoProvConfluenceUiUpdateExperimentDescription': 'Zusammenarbeit an Dokumenten',
  'fabric.atlassianSwitcher.chat': 'Chat',
  'fabric.atlassianSwitcher.companyHub': 'Unternehmens-Hub',
  'fabric.atlassianSwitcher.confluenceDescriptionText': 'Dokumentieren und zusammenarbeiten',
  'fabric.atlassianSwitcher.confluenceSpace': 'Confluence-Bereich',
  'fabric.atlassianSwitcher.emptyState.exploreProducts.body':
    'Testen Sie ein Produkt zur Zusammenarbeit mit Ihrem Team.',
  'fabric.atlassianSwitcher.emptyState.exploreProducts.link': 'Produkte entdecken',
  'fabric.atlassianSwitcher.emptyState.exploreProducts.title': 'Erste Schritte mit der Cloud',
  'fabric.atlassianSwitcher.errorEmptyPartialResults': 'Ihre Apps können derzeit nicht angezeigt werden',
  'fabric.atlassianSwitcher.errorFlag.description':
    'Versuchen Sie es in ein paar Minuten erneut. Wenn Sie immer noch nicht beitreten können, <a>wenden Sie sich an den Support</a>.',
  'fabric.atlassianSwitcher.errorFlag.title': 'Sie konnten {product} nicht hinzugefügt werden',
  'fabric.atlassianSwitcher.errorHeading': 'Irgendetwas ist schiefgelaufen',
  'fabric.atlassianSwitcher.errorHeadingLoggedOut': 'Ihr Atlassian-Konto ist ausgeloggt',
  'fabric.atlassianSwitcher.errorHeadingUnverified': 'Ihr Konto ist nicht verifiziert',
  'fabric.atlassianSwitcher.errorImageAltText': 'Ein kaputter Roboter und viele Menschen, die ihn reparieren.',
  'fabric.atlassianSwitcher.errorPartialResults': 'Einige Ihrer Apps können derzeit nicht angezeigt werden',
  'fabric.atlassianSwitcher.errorPartialResultsRefresh':
    'Aktualisieren Sie die Seite oder versuchen Sie es später erneut.',
  'fabric.atlassianSwitcher.errorText':
    'Wir verfolgen diese Fehler, aber Sie können uns gerne kontaktieren, wenn das Problem nach dem Aktualisieren weiterhin besteht.',
  'fabric.atlassianSwitcher.errorTextLoggedOut': 'Loggen Sie sich wieder ein, um den Atlassian-Switcher zu verwenden.',
  'fabric.atlassianSwitcher.errorTextNetwork':
    'Diese Liste konnte nicht geladen werden. Bitte laden Sie diese Seite neu und versuchen Sie es erneut.',
  'fabric.atlassianSwitcher.errorTextUnverified':
    'Bitte bestätigen Sie Ihre E-Mail-Adresse, um eine Liste der verfügbaren Produkte anzusehen.',
  'fabric.atlassianSwitcher.experimentNudgeToJiraConfluenceDescription':
    'Zeigen Sie Vorgänge in Listen, Boards oder Backlogs an.',
  'fabric.atlassianSwitcher.goals': 'Ziele',
  'fabric.atlassianSwitcher.home': 'Atlassian Home',
  'fabric.atlassianSwitcher.instantAccessStatusText': 'Sofortiger Zugriff',
  'fabric.atlassianSwitcher.jiraDescriptionText': 'Projektabwicklung planen und verfolgen',
  'fabric.atlassianSwitcher.jiraProject': 'Jira-Projekt',
  'fabric.atlassianSwitcher.join': 'Beitreten',
  'fabric.atlassianSwitcher.joinStatusText': 'Beitreten',
  'fabric.atlassianSwitcher.joinTeamStatusText': 'Teil des Teams werden',
  'fabric.atlassianSwitcher.jpdDescriptionText': 'Neue Ideen priorisieren und planen',
  'fabric.atlassianSwitcher.jsmDescriptionText': 'IT-Support automatisieren und leisten',
  'fabric.atlassianSwitcher.jwmInactiveSwitcherWithDefaultItemDescription': 'Projektmanagement für Unternehmensteams',
  'fabric.atlassianSwitcher.jwmInactiveSwitcherWithJSWItemDescription':
    'Kostenlose Verwaltung von Geschäftsprojekten in Jira Software',
  'fabric.atlassianSwitcher.login': 'Einloggen',
  'fabric.atlassianSwitcher.manageList': 'Liste verwalten',
  'fabric.atlassianSwitcher.modalLabel': 'Atlassian-App Switcher',
  'fabric.atlassianSwitcher.more': 'Mehr',
  'fabric.atlassianSwitcher.newLozenge': 'Neu',
  'fabric.atlassianSwitcher.organisationsLabel': 'Organisationen',
  'fabric.atlassianSwitcher.product.description.compass': 'Komponenten-Manager',
  'fabric.atlassianSwitcher.product.description.confluence': 'Zusammenarbeit an Dokumenten',
  'fabric.atlassianSwitcher.product.description.jsm': 'Kollaboratives IT Service Management',
  'fabric.atlassianSwitcher.product.description.jsw': 'Projekt- und Vorgangsnachverfolgung',
  'fabric.atlassianSwitcher.product.description.opsgenie': 'Modernes Vorfallmanagement',
  'fabric.atlassianSwitcher.requestAccessStatusText': 'Zugriff anfordern',
  'fabric.atlassianSwitcher.requestSentStatusText': 'Anfrage gesendet',
  'fabric.atlassianSwitcher.resizeBarLabel': 'Größe des App-Switchers ändern',
  'fabric.atlassianSwitcher.resizeBarTooltipCollapsed': 'Zum Ändern der Größe ziehen{separator}Zum Erweitern drücken',
  'fabric.atlassianSwitcher.resizeBarTooltipExpanded': 'Zum Ändern der Größe ziehen{separator}Zum Reduzieren drücken',
  'fabric.atlassianSwitcher.resizeBarValueTextLabel': 'Breite',
  'fabric.atlassianSwitcher.search': 'Suche',
  'fabric.atlassianSwitcher.sites': '{numSites, plural, one {{productName} Site} other {{productName} Sites}}',
  'fabric.atlassianSwitcher.skeletonLoaderAriaLabel': 'Der App-Switcher wird geladen',
  'fabric.atlassianSwitcher.start': 'Atlassian-Startseite',
  'fabric.atlassianSwitcher.startAriaLabel': 'Die Atlassian-Startseite wird in einer neuen Registerkarte geöffnet.',
  'fabric.atlassianSwitcher.studio': 'Studio',
  'fabric.atlassianSwitcher.successFlag.description': 'Sie erhalten eine E-Mail, sobald der Zugriff genehmigt wurde.',
  'fabric.atlassianSwitcher.successFlag.title': 'Zugriffsanfrage an Administrator gesendet',
  'fabric.atlassianSwitcher.switchSitesOrAppsTooltip': 'Sites oder Apps wechseln',
  'fabric.atlassianSwitcher.switchTo': 'Wechseln zu',
  'fabric.atlassianSwitcher.switchToTooltip': 'Wechseln zu …',
  'fabric.atlassianSwitcher.teams': 'Teams',
  'fabric.atlassianSwitcher.tryLozenge': 'Ausprobieren',
  'fabric.atlassianSwitcher.yourApps': 'Ihre Apps',
  'fabric.atlassianSwitcher.yourAppsTooltip': 'Ihre Apps …',
};
